import _objectSpread from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Cookie from "js-cookie";
import { QS } from "@/lib/utils";
import { IS_SEA } from "@/utils/index.js";
import { addParamsToUrl } from "@/lib/utils.ts";
import { LANG_MAPS } from "@/lib/i18nwordConfig";
var __default__ = {
  data: function data() {
    return {
      IS_SEA: IS_SEA,
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      langList: LANG_MAPS
    };
  },
  methods: {
    onSelect: function onSelect(action) {
      var _useCommon = useCommon(),
        lang = _useCommon.lang;
      if (lang === action.value) {
        this.showPopover = false;
        return;
      }
      var params = _objectSpread(_objectSpread({}, QS), {}, {
        lang: action.value
      });
      var url = addParamsToUrl("".concat(location.origin).concat(location.pathname), params);
      Cookie.set("mi18nLang", action.value);
      window.location.replace(url + location.hash);
    },
    outside: function outside(e) {
      this.showPopover = false;
    }
  }
};
import { vOnClickOutside } from "@vueuse/components";
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'index',
  setup: function setup(__props) {
    var _useCommon2 = useCommon(),
      lang = _useCommon2.lang;
    var langIndex = computed(function () {
      return LANG_MAPS.findIndex(function (_ref) {
        var value = _ref.value;
        return value === lang;
      });
    });
    return {
      __sfc: true,
      lang: lang,
      langIndex: langIndex,
      IS_SEA: IS_SEA,
      vOnClickOutside: vOnClickOutside
    };
  }
});